import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { GoogleButton } from "@/components/GoogleButton";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name}`);
      navigate(location.state?.from || (user.role === "admin" ? "/admin" : user.role === "practitioner" ? "/dashboard" : "/"));
    } catch (err) {
      toast.error(apiError(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="silk-hero min-h-[70vh] flex items-center justify-center px-5 py-20">
      <div className="w-full max-w-md silk-card rounded-lg p-8 sm:p-10">
        <h1 className="font-display text-4xl text-foreground mb-2">Welcome back</h1>
        <p className="text-sm text-muted-foreground mb-8">Sign in to your O.R.E.C account.</p>
        <GoogleButton />
        <div className="flex items-center gap-3 my-6">
          <div className="h-px flex-1 bg-border" /><span className="text-xs text-muted-foreground">or</span><div className="h-px flex-1 bg-border" />
        </div>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label htmlFor="email" className="text-xs uppercase tracking-wider text-muted-foreground">Email</Label>
            <Input id="email" data-testid="login-email-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} className="mt-2" />
          </div>
          <div>
            <div className="flex items-center justify-between">
              <Label htmlFor="password" className="text-xs uppercase tracking-wider text-muted-foreground">Password</Label>
              <Link to="/forgot-password" className="text-xs cream-link" data-testid="forgot-password-link">Forgot password?</Link>
            </div>
            <Input id="password" data-testid="login-password-input" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)} className="mt-2" />
          </div>
          <Button data-testid="login-submit-btn" type="submit" disabled={busy} className="w-full h-11 rounded-full">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <p className="text-sm text-muted-foreground mt-6 text-center">
          New here? <Link to="/register" className="cream-link" data-testid="login-register-link">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
